function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 76 75"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".486",
  width: "75",
  height: "75",
  rx: "28",
  fill: "#A8A5A0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.684 43.64c0-2.865 1.173-5.6 2.996-7.555h-9.51c1.824 1.954 2.997 4.69 2.997 7.556 0 5.471-4.039 10.161-9.38 10.943v3.647h22.147v-3.647c-5.211-.782-9.25-5.342-9.25-10.943z",
  fill: "#403F3E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.231 31.917H22.617c-2.605 0-4.82-2.215-4.82-4.82 0-2.606 2.084-4.82 4.82-4.82h30.744c2.606 0 4.82 2.214 4.82 4.82 0 2.605-2.214 4.82-4.95 4.82z",
  stroke: "#403F3E",
  strokeWidth: "1.637"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.918 58.364h28.14c.39 0 .781-.391.781-.782v-2.996c0-.391-.39-.782-.782-.782H23.918c-.39 0-.781.39-.781.782v2.996c0 .39.39.782.781.782zM48.802 16.154H23.53v10.812c0 4.039 1.433 7.947 3.778 10.813 2.345 2.736 5.472 4.69 9.12 5.08 8.597.913 15.893-6.383 15.893-15.502V16.154h-3.518z",
  fill: "#403F3E"
})));